import { render, staticRenderFns } from "./senderChat.vue?vue&type=template&id=03d5c976&scoped=true&"
import script from "./senderChat.vue?vue&type=script&lang=js&"
export * from "./senderChat.vue?vue&type=script&lang=js&"
import style0 from "./senderChat.vue?vue&type=style&index=0&id=03d5c976&lang=scss&scoped=true&"
import style1 from "./senderChat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5c976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
